module.exports = __webpack_public_path__ + "static/img/29-2.b7638e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/29-2.jpg
// module id = IXX4
// module chunks = 0